export default __webpack_public_path__ + "0aad61797aebf855f35c5b119a54a3ce.svg";